// extracted by mini-css-extract-plugin
module.exports = {"boardDropdown":"BoardManager_boardDropdown__2xVIK"};